import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Master APIs
//TODO: Brand APIs
//  Get Doctor Detail
export const getDoctorDetailAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-doctor-detail`, data,headers);
};
export const getHospitalDetails = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-detail`, data,headers);
};
//!hospital approval
export const hospitalApprovalAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}approvel-hospital`, data,headers);
};
//  Add Doctor
export const addDoctorAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-doctor-admin`, data,headers);
};
//  Update Doctor
export const updateDoctorAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-doctor-admin`, data,headers);
};
//  Review Doctor
export const reviewDoctorAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}review-doctor-admin`, data,headers);
};
//get doctor slot details
export const getDoctorSlotAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-doctor-availability-admin`, data,headers);
};
export const getDoctorOfflineAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-offline-doctor-availability`, data,headers);
};
//add doctor slot details
export const addOfflineDoctorSlotAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-offline-doctor-availability`, data,headers);
};
export const updateOfflineDoctorSlotAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-clinic-availability-admin`, data,headers);
};
//add online doctor slot details
export const addOnlineDoctorSlotAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-doctor-availability-admin`, data,headers);
};
export const deleteClinicAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delete-clinic-availability`, data,headers);
};

//  Get Doctor BookingList
export const getBookingListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}booking-list`, data,headers);
};
export const getMedicineRequest = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-medicine-requests-admin`, data,headers);
};
export const getMedicinesAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-medicine-list`, data,headers);
};
export const addMedicinesAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}add-medicine`, data,headers);
};

export const updateMedicineAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-medicine`, data,headers);
};


export const labAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}lab-list`, data,headers);
};
//  Get Doctor BookingList
export const doctorProfileRegistration = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}doctor-profile-registration`, data,headers);
};
export const createPharmacyStore = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}create-pharmacy-store`, data,headers);
};
//  Get Doctor BookingList
export const doctorQualificationRegistration = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}doctor-qualification-registration`, data,headers);
};
//  Get Doctor BookingList
export const doctorOnlineSlot = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}doctor-online-availability`, data,headers);
};
//  Get Doctor BookingList
export const doctorOfflineSlot = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}doctor-offline-availability`, data,headers);
};
